// Helpers da tela de Upload de Arquivos (PO1-2717).
// Movidos de UploadFilesShipper/index.js, sem mudança de regra, para servirem
// aos dois canais (embarcador e transportador).

export const MAX_ARQUIVOS = 20;
export const MAX_TOTAL_BYTES = 10 * 1024 * 1024;

// O nome do TipoInformacao codifica a extensão esperada (ex.: "NF-e - XML").
// Usado só para o `accept` do input — a validação de fato é feita no servidor
// contra TipoInformacao.Formato.
export function extensaoDoTipo(label) {
  if (!label) return null;
  const match = label.match(/-\s*([A-Za-z]+)\s*$/);
  if (!match) return null;
  return `.${match[1].toLowerCase()}`;
}

export function getEmailFromUser(user) {
  return (user?.EmailAddress || user?.email || user?.Email || "").trim();
}

export function formatBytes(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function parseUploadError(error) {
  const status = error?.response?.status;
  const payload = error?.response?.data || {};
  const responseErrors = Array.isArray(payload?.errors)
    ? payload.errors.filter(Boolean)
    : [];
  const responseError = typeof payload?.error === "string" ? payload.error : "";
  const responseMessage = typeof payload?.message === "string" ? payload.message : "";

  if (status === 409) {
    return {
      title: "Dados duplicados",
      description: responseError || responseMessage || "Foram encontrados dados duplicados.",
      details: responseErrors,
    };
  }

  if (status === 413) {
    return {
      title: "Limite excedido",
      description:
        responseMessage ||
        responseError ||
        "Envio acima do limite de 20 arquivos ou 10 MB. Zipe os arquivos e tente novamente.",
      details: responseErrors,
    };
  }

  // 502: o SFTP recusou parte do envio. O backend devolve `falhas` com o motivo
  // de cada arquivo — antes esse detalhe se perdia no fallback genérico.
  if (status === 502) {
    return {
      title: "Falha no envio ao servidor de arquivos",
      description:
        responseMessage || "Alguns arquivos não chegaram ao destino. Tente novamente.",
      details: (payload?.falhas || []).map((falha) => `${falha.nome}: ${falha.erro}`),
    };
  }

  // 400 com lista de arquivos recusados por extensão.
  if (status === 400 && Array.isArray(payload?.arquivosInvalidos) && payload.arquivosInvalidos.length) {
    return {
      title: "Arquivo incompatível com o tipo",
      description: responseMessage || "Arquivo(s) com extensão incompatível.",
      details: payload.arquivosInvalidos,
    };
  }

  if (responseErrors.length > 0 || responseError || responseMessage) {
    return {
      title: responseError || responseMessage || "Erro ao enviar!",
      description: responseMessage || responseError || "Falha ao importar arquivo.",
      details: responseErrors,
    };
  }

  const isLikelyInvalidFile = status === 400;
  const fallbackMessage = isLikelyInvalidFile
    ? "Arquivo invalido, verifique o arquivo!!"
    : "Nao foi possivel enviar o arquivo. Tente novamente.";

  return {
    title: "Erro ao enviar!",
    description: fallbackMessage,
    details: [],
  };
}
